import styled from '@emotion/styled';

import { t } from '../../../localization/LocaleContext';

const CopyrightText = styled.div`
  color: ${({ theme }) => theme.colors.blueDark20};
`;

const CopyrightHeader = styled.div`
  text-align: center;
  font-weight: 400;

  ${({ theme }) => theme.mediaQuery.md} {
    text-align: left;
    margin-bottom: ${({ theme }) => theme.spacers.s};
  }
`;

const CopyrightBody = styled.div`
  display: none;
  ${({ theme }) => theme.textStyles.labelXs};

  ${({ theme }) => theme.mediaQuery.md} {
    display: block;
  }
`;

export default function Copyright({ size }: { size: string }) {
  const year: number = new Date().getFullYear();

  if (size === 'large') {
    return (
      <div>
        <CopyrightHeader>
          {t('footer_copyright', { currentYear: year })}
        </CopyrightHeader>
        <CopyrightBody>{t('footer_trademark')}</CopyrightBody>
      </div>
    );
  }

  return (
    <CopyrightText>
      {t('footer_copyright', { currentYear: year })}
      <br />
      {t('footer_trademark')}
    </CopyrightText>
  );
}
